<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label >商品搜索:</label>
            <lk-input placeholder='支持商品编码、通用名、商品名' class="item" clearable v-model.trim="query.nameMix"></lk-input>
          </div>
          <div class="queryItem">
            <label >门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div style="margin-bottom:12px;">
          <DownloadButton  @on-click="download" v-if="handlePermission('revInvSearDownload')"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import tools from '../../services/tools';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'receiveInventorySearch',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  data() {
    return {
      query: {

      },
      count: 0,
      columns: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 116 },
        { title: '剩余应收数量', key: 'receivableNum', minWidth: 116 },
        { title: '剩余应收金额', key: 'receivableTotalPrice', minWidth: 116 },
      ],
      tableData: [],
    }
  },
  methods: {
    clear() {
      this.query = {};
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      tools.receiveInDownload(params).then(res => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      tools.receiveInSearch(this.params).then(res => {
        if (res.data.status === 200) {
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    this.handleSearch(true);
  },
}
</script>
